import React from 'react'
import Footer from 'components/footer'
import Header from 'components/header'
import { Container, Row, Col } from 'react-bootstrap'


export default function Layout(props) {
    return (
        <div className="App">
            <Container className='vh-100'>
                <Header />
                <Container>
                    <Row>
                        <Col xs={12}>
                            {props.children}
                        </Col>
                    </Row>
                    <Footer />
                </Container>
            </Container>
        </div>
    )
}
